import { useTranslation } from "react-i18next";
import { stdObject } from "../../../data/types/stdObject";
import WriteInput from "../WriteInput";
import { useSelector } from "react-redux";
import { RootState } from "../../../store/store";
import { useMemo, useState } from "react";
import { getTaxList } from "../../../screens/MainFrame/functions/getTaxList";
import OffersRow from "./OffersRow";
import { colors } from "../../../data/colors";
import { useMainContext } from "../../../context/MainContext";
import { addNewOffer } from "../../../screens/MainFrame/functions/item/addNewOffer";

export default function Prices({ data = {} }: stdObject) {
  const { t } = useTranslation();
  const { windowValues2, setWindowValues2 } = useMainContext();
  const user: any = useSelector((state: RootState) => state.data.user);
  const [country, setCountry] = useState(user.CODPAI);
  const countries: Array<stdObject> = useSelector(
    (state: RootState) => state.data.pai,
  );
  const pricesRates: Array<stdObject> = useSelector(
    (state: RootState) => state.data.tar,
  );

  const searchOptions: any = useSelector(
    (state: RootState) => state.data.search,
  );

  const countriesList = useMemo(
    () =>
      countries
        .filter((e) => e.ACTPAI === 1)
        .map((e) => {
          return { label: t(`country.${e.CODPAI}`), value: e.CODPAI };
        }),
    [countries],
  );
  const taxesList: Array<stdObject> = useSelector((state: RootState) =>
    state.data.imp.filter((e: stdObject) => e.CODIMP === user.CODPAI),
  );

  const updatePricesValues = ({
    type,
    code,
    field = "",
    value,
  }: {
    type: string;
    code: string | number;
    field?: string;
    value: string;
  }) => {
    let tempData: stdObject = data.value;
    if (!tempData) {
      tempData = {};
    }
    if (!(type in tempData)) {
      tempData[type] = {};
    }
    if (!(country in tempData[type])) {
      tempData[type][country] = {};
    }
    switch (type) {
      case "prices":
      case "insurances":
        if (!(code in tempData[type][country])) {
          tempData[type][country][code] = {};
        }
        tempData[type][country][code][field] = Number(value);
        break;
      case "cost":
      case "taxes":
        tempData[type][country][code] = Number(value);
        break;
    }

    data.onChange({ target: { value: tempData } });
  };

  return (
    <>
      <table>
        <tbody>
          {countriesList.length > 1 && (
            <WriteInput
              data={{
                label: t("p.country"),
                code: "PAI",
                value: country,
                type: "select",
                options: countriesList,
                onChange: (v: { target: { value: string } }) => {
                  setCountry(Number(v.target.value));
                },
              }}
              isTable={true}
            />
          )}
          <WriteInput
            data={{
              label: t("p.cost"),
              code: "PCO",
              value:
                typeof data.value?.cost?.[country]?.PREPCO === "number" &&
                data.value.cost[country].PREPCO !== 0
                  ? data.value.cost[country].PREPCO
                  : "",
              type: "number",
              active: data.active,
              innerStyle: { width: 100 },
              onChange: (v: { target: { value: string } }) =>
                updatePricesValues({
                  type: "cost",
                  code: "PREPCO",
                  value: v.target.value,
                }),
              onFocus: () => {
                updatePricesValues({
                  type: "cost",
                  code: "PREPCO",
                  value: data.value?.cost?.[country]?.PREPCO
                    ? Number(data.value.cost[country].PREPCO).toString()
                    : "",
                });
              },
            }}
            isTable={true}
          />
          <WriteInput
            data={{
              label: t("p.tax"),
              code: "ARI",
              value:
                data.value && data.value.taxes && data.value.taxes[country]
                  ? data.value.taxes[country].IMPARI
                  : 0,
              type: "select",
              options: getTaxList(0, taxesList),
              active: data.active,
              onChange: (v: { target: { value: string } }) =>
                updatePricesValues({
                  type: "taxes",
                  code: "IMPARI",
                  value: v.target.value,
                }),
            }}
            isTable={true}
          />
          {pricesRates.map((e, index) => (
            <WriteInput
              key={index}
              data={{
                label: e.NOMTAR,
                code: e.CODTAR,
                value:
                  typeof data.value?.prices?.[country]?.[e.CODTAR]?.PRELTA ===
                    "number" &&
                  data.value.prices[country][e.CODTAR].PRELTA !== 0
                    ? data.value.prices[country][e.CODTAR].PRELTA
                    : "",
                type: "number",
                active: data.active,
                innerStyle: { width: 100 },
                onChange: (v: { target: { value: string } }) =>
                  updatePricesValues({
                    type: "prices",
                    code: e.CODTAR,
                    field: "PRELTA",
                    value: v.target.value,
                  }),
                onFocus: () => {
                  const intValue = data.value?.prices?.[country]?.[e.CODTAR]
                    ?.PRELTA
                    ? Number(
                        data.value.prices[country][e.CODTAR].PRELTA,
                      ).toString()
                    : "";
                  updatePricesValues({
                    type: "prices",
                    code: e.CODTAR,
                    field: "PRELTA",
                    value: intValue,
                  });
                },
              }}
              isTable={true}
            />
          ))}
          <WriteInput
            data={{
              label: t("p.offers"),
              type: "label",
            }}
            isTable={true}
          />
        </tbody>
      </table>
      <table width={"100%"} cellSpacing={0} cellPadding={2}>
        <tbody>
          {data.value &&
            country in data.value.offers &&
            data.value.offers[country].map((e: stdObject, index: number) => (
              <OffersRow
                key={index}
                index={index}
                data={e}
                country={country}
                active={data.active}
              />
            ))}
          <tr>
            <td align="center" colSpan={5} style={{ padding: 5 }}>
              <div
                className="miniButton noSelect"
                style={{ backgroundColor: colors.green }}
                onClick={() =>
                  addNewOffer(country, {}, { windowValues2, setWindowValues2 })
                }
              >
                {t("p.addOffer")}
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <table width={"100%"}>
        <tbody>
          <WriteInput
            data={{
              label: t("p.insurances"),
              type: "label",
            }}
            isTable={4}
          />
          {searchOptions.docInsurances.map((e: stdObject, index: number) => (
            <tr key={index}>
              <td>{e.NOMPSE}</td>
              <td width={100}>
                <WriteInput
                  data={{
                    value:
                      data.value?.insurances?.[country]?.[e.CODPSE]?.TIPPS0 ??
                      "0",
                    type: "select",
                    options: [
                      { label: t("p.price"), value: "0" },
                      { label: t("p.percentage"), value: "1" },
                    ],
                    onChange: (v: { target: { value: string } }) =>
                      updatePricesValues({
                        type: "insurances",
                        code: e.CODPSE,
                        field: "TIPPS0",
                        value: v.target.value,
                      }),
                  }}
                />
              </td>
              <td>
                <WriteInput
                  data={{
                    value:
                      data.value?.insurances?.[country]?.[e.CODPSE]?.VALPS0,
                    type: "number",
                    style: { textAlign: "left" },
                    innerStyle: { width: 100 },
                    onChange: (v: { target: { value: string } }) =>
                      updatePricesValues({
                        type: "insurances",
                        code: e.CODPSE,
                        field: "VALPS0",
                        value: v.target.value,
                      }),
                  }}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );
}
